// Table
import Table from '../ui/table/Table'

// UI
import { Anchor } from '@mantine/core'
import Badge from '../ui/Badge'

// Next
import { Link } from 'react-router-dom'

// Cells
const NameCell = (item) => (
    <Link
        to={`/retailers/${item.id}`}
        className="table-cell p-5 hover:bg-gray-100"
    >
        <div className="flex gap-6 items-center">
            <div className="flex flex-col items-start">
                <Anchor component="span">{item.name}</Anchor>
                <span className="text-xs text-gray-500">
                    {item.sellsy_name}
                </span>
            </div>
        </div>
    </Link>
)

const ShippingCell = (item) => (
    <div className="table-cell p-5 align-middle">
        <span className="text-sm">
            {item.has_free_shipping ? (
                <Badge color="green" size="xs">
                    Offerts
                </Badge>
            ) : (
                <Badge color="orange" size="xs">
                    Payants
                </Badge>
            )}
        </span>
    </div>
)

const SellsyCell = (item) => (
    <div className="table-cell p-5 align-middle">
        {item.sellsy_company_id ? (
            <Badge color="green" size="xs">
                Relié à Sellsy
            </Badge>
        ) : (
            <Badge color="gray" size="xs">
                Non relié à Sellsy
            </Badge>
        )}
    </div>
)

export default function RetailerTable() {
    const availableColumns = [
        {
            name: 'Nom',
            key: 'name',
            display: 'mandatory',
            sortable: true,
            component: NameCell,
        },
        {
            name: 'Sellsy',
            key: 'sellsy_company_id',
            display: 'optional',
            sortable: true,
            component: SellsyCell,
            width: 200,
        },
        {
            name: 'Frais de port',
            key: 'has_free_shipping',
            display: 'optional_default',
            sortable: true,
            component: ShippingCell,
            width: 200,
        },
    ]

    const availableFilters = []

    return (
        <Table
            engineApiEndpoint="retailers"
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            searchable={true}
            defaultSortColumn="name"
            defaultSortDirection="asc"
        />
    )
}
